const CACHE_KEY = "wip_data_cache";
const CACHE_TIME = 10 * 60 * 1000; // 10 minutes in milliseconds

export const getCachedData = async () => {
  const cached = localStorage.getItem(CACHE_KEY);
  const now = new Date().getTime();

  if (cached) {
    const { data, timestamp } = JSON.parse(cached);
    if (now - timestamp < CACHE_TIME) {
      console.log("Loading from cache...");
      return data;
    }
  }

  // If no cache or cache expired, fetch new data
  console.log("Cache expired. Fetching fresh data...");
  const response = await fetch("/Data/db.json");
  const data = await response.json();
  
  localStorage.setItem(CACHE_KEY, JSON.stringify({ data, timestamp: now }));
  return data;
};